import React, { Component } from 'react';
import axios from 'axios';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';
import Message from '../../partials/Message';
import Icon from '../../partials/Icon';

export default class Student extends Component {
    state = {
        errors: '',
        message: '',
        student: {
            id: '',
            first_name: '',
            group_id: ''
        },
        isOpen: false
    }

    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
        this.inputChange = this.inputChange.bind(this);
        this.toggleForm = this.toggleForm.bind(this);
        this.remove = this.remove.bind(this);
    }

    componentDidMount() {
        this.setState({ student: {
            id: this.props.student.id,
            first_name: this.props.student.first_name,
            group_id: this.props.group_id
        } });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ student: {
            id: nextProps.student.id,
            first_name: nextProps.student.first_name,
            group_id: nextProps.group_id
        } });
    }

    inputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ student: {...this.state.student, [name]: value } });
    }

    submit(event) {
        event.preventDefault();

        axios.put(API_URL+'/admin/students/'+this.state.student.id, {
            first_name: this.state.student.first_name,
            group_id: this.state.student.group_id
        })
        .then(response => {
            this.props.update();
            this.setState({ message: 'Användaren sparades.' });
        })
        .catch(error => {
            // Valideringsfel
            if (error.response && error.response.status === 422) {
                this.setState({ errors: error.response.data }); 
            }
            // Annat fel
            if (error.response && error.response.status === 400) {
                this.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
            }
        });
    }

    remove(event) {
        axios.delete(API_URL+'/admin/students/'+this.state.student.id)
        .then(response => {
            this.props.update();
        })
        .catch(error => {
            // Annat fel
            if (error.response && error.response.status === 400) {
                this.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
            }
        });
    }

    toggleForm(event) {
        event.preventDefault();
    
        this.state.isOpen ? this.setState({ isOpen: false }) : this.setState({ isOpen: true });
    }

    render() {
        return (
            <li>
                <Icon icon="user" color="pink" />
                <a onClick={ this.toggleForm }>{ this.props.student.first_name }</a>
                <span className="right">{ this.props.student.code }</span>
                
                <div className={ this.state.isOpen ? '' : 'hidden' }>
                    <Errors errors={ this.state.errors } />
                    <Message message={ this.state.message} />

                    <form onSubmit={ this.submit }>
                        <label>Namn</label>
                        <input type="text" name="first_name" required value={ this.state.student.first_name } onChange={ this.inputChange } />

                        <input className="button purple" type="submit" value="Spara" />
                    </form>
                    
                    <div className="danger-zone">
                        <h3>Ta bort</h3>
                        <p>Obs! Detta går inte att ångra.</p>
                        <button onClick={ this.remove }>Ta bort</button>
                    </div>
                </div>
            </li>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/Group/Student.js